<template>
    <div class="NodeEditor DecisionNodeEditor">
        <NodeSaveStatus></NodeSaveStatus>
        <!--Header Editor-->
        <NodeHeaderEditor
            key="NodeHeaderEditor"
            :name.sync="node.name"
            :slug="node.slug"
            :id="node.id"
            :type="node.type"
            ref="NodeHeaderEditor"
            @save="saveNode"
            @delete="deleteNode"
            @close="closePanelRight"
        ></NodeHeaderEditor>
        <!--Content Editor-->
        <v-tabs slider-color="#FFFFFF" v-model="currentTab" v-if="node.config.cardList.length > 0">
            <v-tab :href="`#tab-condition`">{{ $f.tc('condition') }}</v-tab>
            <v-tab :href="`#tab-action`">{{ $t('action') | capitalize }}</v-tab>
            <v-tabs-items touchless v-model="currentTab">
                <v-tab-item :value="`tab-condition`">
                    <div class="scroll-container fci-scrollbar">
                        <ScenarioCard name="Condition">
                            <ConditionEditor :items="node.config.conditionList" @save="saveNode"></ConditionEditor>
                        </ScenarioCard>
                    </div>
                </v-tab-item>
                <v-tab-item :value="`tab-action`">
                    <div class="scroll-container fci-scrollbar">
                        <ScenarioCard
                            v-for="(card, cardIndex) in node.config.cardList"
                            :key="cardIndex"
                            :name.sync="card.name"
                            @delete="deleteCard(cardIndex)"
                            @moveUp="moveCardUp(cardIndex)"
                            @moveDown="moveCardDown(cardIndex)"
                            @updateCardName="newName => updateCardName(newName, cardIndex)"
                            :delete-able="isEdit"
                            :move-able="isEdit"
                            :name-editable="isEdit"
                            :name-invalid="['init', 'end']"
                        >
                            <ApiEditor
                                v-if="card.type === CardType.API"
                                :item.sync="card.data"
                                ref="card"
                                @save="shouldSave ? saveNode() : null"
                                :editable="isEdit"
                            ></ApiEditor>
                            <ApiParameterEditor
                                v-if="card.type === CardType.SET_USER_ATTRIBUTE"
                                :items.sync="card.data"
                                ref="card"
                                @save="shouldSave ? saveNode() : null"
                                :editable="isEdit"
                            ></ApiParameterEditor>
                            <LuaEditor
                                v-if="card.type === CardType.LUA"
                                :item.sync="card.data"
                                @save="shouldSave ? saveNode() : null"
                                :editable="isEdit"
                                ref="card"
                            ></LuaEditor>
                        </ScenarioCard>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
        <div v-else class="scroll-container fci-scrollbar">
            <ScenarioCard name="Condition">
                <ConditionEditor :items="node.config.conditionList" @save="saveNode"></ConditionEditor>
            </ScenarioCard>
        </div>
        <!--Footer Editor-->
        <NodeFooterEditor
            :actions-not-use="[NodeEditorMenuCode.ADD_SETTING, NodeEditorMenuCode.ADD_AUDIO_ENGINE, NodeEditorMenuCode.ADD_NLP_CONFIG]"
            @menuSelect="onMenuSelect($event)"
        ></NodeFooterEditor>
    </div>
</template>

<script>
import NodeEditor from "@/views/Scenario/NodeEditor/NodeEditor";
import ConditionEditor from "@/views/Scenario/NodeEditor/common/ConditionEditor";
import NodeHeaderEditor from "@/views/Scenario/NodeEditor/common/NodeHeaderEditor";
import ScenarioCard from "@/views/Scenario/components/ScenarioCard";
import ApiEditor from "@/views/Scenario/NodeEditor/common/ApiEditor";
import ApiParameterEditor from "@/views/Scenario/NodeEditor/common/ApiParameterEditor";
import NodeSaveStatus from "@/views/Scenario/NodeEditor/NodeSaveStatus";
import NodeFooterEditor from "@/views/Scenario/NodeEditor/common/NodeFooterEditor";
import LuaEditor from "@/views/Scenario/NodeEditor/common/LuaEditor";
import ScenarioService from "@/services/scenario.service";

const {NodeEditorMenuCode} = ScenarioService

export default {
    name: "DecisionNodeEditor",
    extends: NodeEditor,
    components: {
        NodeFooterEditor,
        ConditionEditor,
        NodeHeaderEditor,
        ScenarioCard,
        ApiEditor,
        ApiParameterEditor,
        NodeSaveStatus,
        LuaEditor
    },
    data() {
        return {
            NodeEditorMenuCode
        }
    },
    methods: {
        validateNodeData() {
            if (!this.node.name) {
                return 'Name not valid'
            }
            let validateConditionList = this.validateConditionList(this.node.config.conditionList)
            if (validateConditionList !== true) {
                return validateConditionList
            }
            return true
        }
    }
}
</script>
<style scoped lang="scss">
@import "NodeEditor.scss";

.condition-scroll {
    height: calc(100% - 49px);
    overflow-y: auto;
    padding-bottom: 52px;
}
</style>
